export interface RouteStationPositionData {
    latitude: number | undefined;
    longitude: number | undefined;
}

export enum RouteStationPositionDataTypes {
    latitude,
    longitude
}